const configJson = {
  configSettingsValues: {
    disablingBenchmarkAccuracyThresholdDisableAttempt: {
      displayLabel: 'Disable threshold',
      leaf: true,
      name: 'disablingBenchmarkAccuracyThresholdDisableAttempt',
      path: 'configSettingsValues.disablingBenchmarkAccuracyThresholdDisableAttempt',
      source: 'project',
      value: 0.4,
      _type: 'Number',
    },
    disablingBenchmarkAccuracyThresholdDisableL0: {
      displayLabel: 'L0: disable threshold',
      leaf: true,
      name: 'disablingBenchmarkAccuracyThresholdDisableL0',
      path: 'configSettingsValues.disablingBenchmarkAccuracyThresholdDisableL0',
      source: 'project',
      value: 0.4,
      _type: 'Number',
    },
    disablingBenchmarkAccuracyThresholdDisableL1: {
      displayLabel: 'L1: disable threshold',
      leaf: true,
      name: 'disablingBenchmarkAccuracyThresholdDisableL1',
      path: 'configSettingsValues.disablingBenchmarkAccuracyThresholdDisableL1',
      source: 'project',
      value: 0.4,
      _type: 'Number',
    },
    disablingBenchmarkAccuracyThresholdDisableReviewConsensus: {
      displayLabel: 'ReviewConsensus: disable threshold',
      leaf: true,
      name: 'disablingBenchmarkAccuracyThresholdDisableReviewConsensus',
      path: 'configSettingsValues.disablingBenchmarkAccuracyThresholdDisableReviewConsensus',
      source: 'project',
      value: 0.4,
      _type: 'Number',
    },
    disablingBenchmarkAccuracyThresholdDisableL10: {
      displayLabel: 'L10: disable threshold',
      leaf: true,
      name: 'disablingBenchmarkAccuracyThresholdDisableL10',
      path: 'configSettingsValues.disablingBenchmarkAccuracyThresholdDisableL10',
      source: 'project',
      value: 0.4,
      _type: 'Number',
    },
    disablingBenchmarkAccuracyThresholdMinTaskCountAttempt: {
      displayLabel: 'Min benchmark count',
      leaf: true,
      value: 5,
      _type: 'Number',
    },
    disablingBenchmarkAccuracyThresholdMinTaskCountL0: {
      displayLabel: 'L0: min benchmark count',
      leaf: true,
      value: 5,
      _type: 'Number',
    },
    disablingBenchmarkAccuracyThresholdMinTaskCountL1: {
      displayLabel: 'L1: min benchmark count',
      leaf: true,
      value: 5,
      _type: 'Number',
    },
    disablingBenchmarkAccuracyThresholdMinTaskCountReviewConsensus: {
      displayLabel: 'ReviewConsensus: min benchmark count',
      leaf: true,
      value: 5,
      _type: 'Number',
    },
    disablingBenchmarkAccuracyThresholdMinTaskCountL10: {
      displayLabel: 'L10: min benchmark count',
      leaf: true,
      value: 5,
      _type: 'Number',
    },
    disablingBenchmarkAccuracyThresholdMinWarnTaskCountAttempt: {
      displayLabel: 'Min warn benchmark count',
      leaf: true,
      _type: 'Number',
    },
    disablingBenchmarkAccuracyThresholdMinWarnTaskCountL0: {
      displayLabel: 'L0: min warn benchmark count',
      leaf: true,
      _type: 'Number',
    },
    disablingBenchmarkAccuracyThresholdMinWarnTaskCountL1: {
      displayLabel: 'L1: min warn benchmark count',
      leaf: true,
      _type: 'Number',
    },
    disablingBenchmarkAccuracyThresholdMinWarnTaskCountL10: {
      displayLabel: 'L10: min warn benchmark count',
      leaf: true,
      _type: 'Number',
    },
    disablingBenchmarkAccuracyThresholdWarnAttempt: {
      displayLabel: 'Warn threshold',
      leaf: true,
      name: 'disablingBenchmarkAccuracyThresholdWarnAttempt',
      path: 'configSettingsValues.disablingBenchmarkAccuracyThresholdWarnAttempt',
      source: 'project',
      value: 0.7,
      _type: 'Number',
    },
    disablingBenchmarkAccuracyThresholdWarnL0: {
      displayLabel: 'L0: warn threshold',
      leaf: true,
      name: 'disablingBenchmarkAccuracyThresholdWarnL0',
      path: 'configSettingsValues.disablingBenchmarkAccuracyThresholdWarnL0',
      source: 'project',
      value: 0.3,
      _type: 'Number',
    },
    disablingBenchmarkAccuracyThresholdWarnL1: {
      displayLabel: 'L1: warn threshold',
      leaf: true,
      name: 'disablingBenchmarkAccuracyThresholdWarnL1',
      path: 'configSettingsValues.disablingBenchmarkAccuracyThresholdWarnL1',
      source: 'project',
      value: 0.3,
      _type: 'Number',
    },
    disablingBenchmarkAccuracyThresholdWarnReviewConsensus: {
      displayLabel: 'ReviewConsensus: warn threshold',
      leaf: true,
      name: 'disablingBenchmarkAccuracyThresholdWarnReviewConsensus',
      path: 'configSettingsValues.disablingBenchmarkAccuracyThresholdWarnReviewConsensus',
      source: 'project',
      value: 0.3,
      _type: 'Number',
    },
    disablingBenchmarkAccuracyThresholdWarnL10: {
      displayLabel: 'L10: warn threshold',
      leaf: true,
      name: 'disablingBenchmarkAccuracyThresholdWarnL10',
      path: 'configSettingsValues.disablingBenchmarkAccuracyThresholdWarnL10',
      source: 'project',
      value: 0.3,
      _type: 'Number',
    },
  },
};

export default configJson;
